import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { LoginComponent } from './login/login.component';
import { AppRoutingModule } from '../app-routing.module';
import { ImagePreviewComponent } from './image-preview/image-preview.component';
import { CommonModule } from '@angular/common';
import { PrintComponent } from './print/print.component';
import { LoadingComponent } from './loading/loading.component';
import { PreVentaComponent } from './pre-venta/pre-venta.component';
import { SliderComponent } from './slider/slider.component';
import { FooterComponent } from './footer/footer.component';
import { MarcasComponent } from './marcas/marcas.component';
import { ItemViewComponent } from './item-view/item-view.component';
import { NgbActiveModal, NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NavigatorButtonComponent } from './navigator-button/navigator-button.component';
import { ProductDetailComponent } from './productDetail/product-detail.component';
import { PreguntaComponent } from './pregunta/pregunta.component';
import { QuienesSomosComponent } from './quienes-somos/quienes-somos.component';


@NgModule({
   declarations: [
      LoginComponent,
      ImagePreviewComponent,
      PrintComponent,
      LoadingComponent,
      PreVentaComponent,
      SliderComponent,
      FooterComponent,
      MarcasComponent,
      ItemViewComponent,
      ProductDetailComponent,
      NavigatorButtonComponent,
      PreguntaComponent,
      QuienesSomosComponent
   ],
   imports: [
      BrowserModule,
      CommonModule,
      AppRoutingModule,
      FormsModule,
      NgbModule,
      NgbDropdownModule,


   ],
   exports: [
      LoginComponent,
      ImagePreviewComponent,
      PrintComponent,
      LoadingComponent,
      PreVentaComponent,
      SliderComponent,
      FooterComponent,
      MarcasComponent,
      ProductDetailComponent,
      ItemViewComponent,
      NavigatorButtonComponent,
      PreguntaComponent,
      QuienesSomosComponent
   ],
   providers: [NgbActiveModal],
})
export class SharedModule { }
